import { name } from "file-loader";

export default [
  {
    path: "/app/servers",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Servidores",
      requiresAuth: true,
    },
    children: [
      //----------------------------Servers----------------------------\\
      {
        path: "function-servers",
        name: "servers.function-servers",
        component: () => import("../function-servers/views/List.vue"),
        meta: {
          permission: "view_server",
        },
      },
      {
        path: "function-servers/create",
        name: "servers.function-servers.create",
        component: () => import("../function-servers/views/Create.vue"),
        meta: {
          permission: "view_server",
        },
      },
      {
        path: "function-servers/show/:id",
        name: "servers.function-servers.show",
        component: () => import("../function-servers/views/Show.vue"),
        meta: {
          permission: "view_server",
        },
      },
      {
        path: "function-servers/edit/:id",
        name: "servers.function-servers.edit",
        component: () => import("../function-servers/views/Edit.vue"),
        meta: {
          permission: "view_server",
        },
      },

      //----------------------------report Teachers Subject Taught Class----------------------------\\

      {
        path: "teachers-subjects-taught-class",
        name: "servers.teachers-subjects-taught-class",
        component: () =>
          import("../teachers-subjects-taught-class/views/List.vue"),
        meta: {
          permission: "view_server",
        },
      },
      // time table
      {
        path: "time-table",
        name: "servers.time-table",
        component: () => import("../time-table/views/List.vue"),
        meta: {
          permission: "view_time_table",
        },
      },
      {
        path: "time-table/create",
        name: "servers.time-table.create",
        component: () => import("../time-table/views/Create.vue"),
        meta: {
          permission: "view_time_table",
        },
      },
      {
        path: "time-table/:id",
        name: "servers.time-table.edit",
        component: () => import("../time-table/views/Edit.vue"),
        meta: {
          permission: "view_time_table",
        },
      },
      {
        path: "time-table/:id/time-time-table",
        name: "servers.time-table.time-time-table",
        component: () => import("../time-table/views/Show.vue"),
        meta: {
          permission: "view_time_table",
        },
      },

      //----------------------------Register Types----------------------------\\
      // Category levels
      {
        path: "register/types/category-levels",
        name: "servers.register.types.category-levels",
        component: () => import("../type/category-levels/views/List.vue"),
        meta: {
          permission: "view_type_category_level",
        },
      },
      {
        path: "register/types/category-levels/create",
        name: "servers.register.types.category-levels.create",
        component: () => import("../type/category-levels/views/Create.vue"),
        meta: {
          permission: "view_type_category_level",
        },
      },
      {
        path: "register/types/category-levels/edit/:id",
        name: "servers.register.types.category-levels.edit",
        component: () => import("../type/category-levels/views/Edit.vue"),
        meta: {
          permission: "view_type_category_level",
        },
      },
      {
        path: "register/types/category-levels/show/:id",
        name: "servers.register.types.category-levels.show",
        component: () => import("../type/category-levels/views/Show.vue"),
        meta: {
          permission: "view_type_category_level",
        },
      },
      {
        path: "register/types/category-levels/levels/:id",
        name: "servers.register.types.category-levels.levels",
        component: () => import("../type/category-levels/views/Levels.vue"),
        meta: {
          permission: "view_type_category_level",
        },
      },

      // Roles
      {
        path: "register/types/roles",
        name: "servers.register.types.roles",
        component: () => import("../type/roles/views/List.vue"),
        meta: {
          permission: "view_type_role",
        },
      },
      {
        path: "register/types/roles/create",
        name: "servers.register.types.roles.create",
        component: () => import("../type/roles/views/Create.vue"),
        meta: {
          permission: "view_type_role",
        },
      },
      {
        path: "register/types/roles/edit/:id",
        name: "servers.register.types.roles.edit",
        component: () => import("../type/roles/views/Edit.vue"),
        meta: {
          permission: "view_type_role",
        },
      },
      {
        path: "register/types/roles/show/:id",
        name: "servers.register.types.roles.show",
        component: () => import("../type/roles/views/Show.vue"),
        meta: {
          permission: "view_type_role",
        },
      },

      // Reason Removals
      {
        path: "register/types/reason-removals",
        name: "servers.register.types.reason-removals",
        component: () => import("../type/reason-removals/views/List.vue"),
        meta: {
          permission: "view_type_reason_removal",
        },
      },
      {
        path: "register/types/reason-removals/create",
        name: "servers.register.types.reason-removals.create",
        component: () => import("../type/reason-removals/views/Create.vue"),
        meta: {
          permission: "view_type_reason_removal",
        },
      },
      {
        path: "register/types/reason-removals/edit/:id",
        name: "servers.register.types.reason-removals.edit",
        component: () => import("../type/reason-removals/views/Edit.vue"),
        meta: {
          permission: "view_type_reason_removal",
        },
      },
      {
        path: "register/types/reason-removals/show/:id",
        name: "servers.register.types.reason-removals.show",
        component: () => import("../type/reason-removals/views/Show.vue"),
        meta: {
          permission: "view_type_reason_removal",
        },
      },
      // Educations
      {
        path: "register/types/educations",
        name: "servers.register.types.educations",
        component: () => import("../type/educations/views/List.vue"),
        meta: {
          permission: "view_type_schooling",
        },
      },
      {
        path: "register/types/educations/create",
        name: "servers.register.types.educations.create",
        component: () => import("../type/educations/views/Create.vue"),
        meta: {
          permission: "view_type_schooling",
        },
      },
      {
        path: "register/types/educations/edit/:id",
        name: "servers.register.types.educations.edit",
        component: () => import("../type/educations/views/Edit.vue"),
        meta: {
          permission: "view_type_schooling",
        },
      },
      {
        path: "register/types/educations/show/:id",
        name: "servers.register.types.educations.show",
        component: () => import("../type/educations/views/Show.vue"),
        meta: {
          permission: "view_type_schooling",
        },
      },
      // Employee Bonds
      {
        path: "register/types/employee-bonds",
        name: "servers.register.types.employee-bonds",
        component: () => import("../type/employee-bonds/views/List.vue"),
        meta: {
          permission: "view_type_employee_bond",
        },
      },
      {
        path: "register/types/employee-bonds/create",
        name: "servers.register.types.employee-bonds.create",
        component: () => import("../type/employee-bonds/views/Create.vue"),
        meta: {
          permission: "view_type_employee_bond",
        },
      },
      {
        path: "register/types/employee-bonds/edit/:id",
        name: "servers.register.types.employee-bonds.edit",
        component: () => import("../type/employee-bonds/views/Edit.vue"),
        meta: {
          permission: "view_type_employee_bond",
        },
      },
      {
        path: "register/types/employee-bonds/show/:id",
        name: "servers.register.types.employee-bonds.show",
        component: () => import("../type/employee-bonds/views/Show.vue"),
        meta: {
          permission: "view_type_employee_bond",
        },
      },
    ],
  },
];
